import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import MenuLanding from "@/pages/MenuLanding";
import MenuPage from "@/pages/MenuPage";
import AdminLogin from "@/pages/AdminLogin";
import KitchenPage from "@/pages/KitchenPage";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App font-body">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MenuLanding />} />
            <Route
              path="/menu/:menuType"
              element={
                <CartProvider>
                  <MenuPage />
                </CartProvider>
              }
            />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <KitchenPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
